<template>
    <div id="airplane-wind-chart" 
        class="base-popup monitor-graph" 
    >
        <v-card v-if="Object.keys(chart_options)"
            class="base-popup__wrapper" 
        >
            <div id="base-popup__capture_range">
                <div class="base-popup__content">
                    <div class="base-popup__content-detail d-flex align-center justify-space-between">
                        <span>{{ chart_options.airport_code }} {{ chart_options.airport_ch_name }}</span>
                        <span></span>
                        <div>
                            <v-btn
                                id="tsgraph-download" 
                                @click="save_png"
                                icon
                            >
                                <v-icon color="black">
                                    icon-file-download
                                </v-icon>
                            </v-btn>
                            <v-btn
                                class="close-btn"
                                color="black"
                                icon
                                @click="close_dialog"
                            >
                                <v-icon color="black">
                                    mdi-close
                                </v-icon>
                            </v-btn>
                        </div>
                    </div>
                    <div class="base-popup__content-graph">
                        <div class="wind-profiler">
                            <div ref="chart" class="wind-profiler-chart"></div>
                        </div>
                    </div>
                </div>
            </div>
        </v-card>
        <div v-else-if="error_text">
            <v-alert
                :value="true"
                type="info"
                class="error__box"
                color="#ee3934"
            >
                {{ error_text }}
                <v-btn
                    class="error__close-btn"
                    color="white"
                    icon
                    @click="close_dialog"
                >
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-alert>
        </div>
        <LoadingHint v-else
            :text="$t('__chart_common.loading_text')"
        />
    </div>
</template>

<script>
import * as echarts from 'echarts'
import { take_screenshot } from '@/utils/common/screenshot.js'
import LoadingHint from '@/components/common/loading_hint.vue'
export default {
    name: 'AirplaneWindChart',

    components: {
        LoadingHint,
    },

    props: {
        chart_options: {
            type: Object,
            required: true,
        },
    },

    data() {
        return {
            title: '',
            setting: {
                y: {
                    min: 0,
                    max: 10000,
                },
                barb: {
                    len: 20,
                    fletching_len: 10,
                    interval: 0.08,
                },
                w: {
                    min: -10,
                    max: 10,
                    unit: 'm/s',
                },
                invalid_val: -9999,
            },
            target: null,
            chart_data: [],
            error_text: '',
        }
    },

    computed: {},

    async mounted() {
        this.init()
        this.draw()
    },

    methods: {
        draw() {
            // this.random_data()
            this.parsed_data(this.chart_options)
        },
        random_data() {
            // 模擬數據
            var ts_list = new Array(30).fill(1).map((o, i) => +new Date('2024/12/01') + i * 1000 * 60 * 10)
            var heights = [
                0,
                500,
                1000,
                1500,
                2000,
                2500,
                3000,
                3500,
                4000,
                4500,
                5000,
                5500,
                6000,
                6500,
                7000,
                7500,
                8000,
                8500,
                9000,
                9500,
                10000,
            ]
            var data = [
                {
                    ts: +new Date('2024/11/30 23:50'),
                    height: 5000,
                    spd: 143,
                    dir: 0,
                    w: 10,
                },
                {
                    ts: +new Date('2024/11/30 23:50'),
                    height: 7000,
                    spd: 0,
                    dir: 90,
                    w: 5,
                },
                {
                    ts: +new Date('2024/11/30 23:50'),
                    height: 8000,
                    spd: 20,
                    dir: 180,
                    w: 0,
                },
                {
                    ts: +new Date('2024/11/30 23:50'),
                    height: 10000,
                    spd: 50,
                    dir: 270,
                    w: -10,
                },
            ]

            for (var i = 0; i < ts_list.length; i++) {
                for (var j = 0; j < heights.length; j++) {
                    var spd = Math.random() * 150
                    var dir = Math.random() * 90
                    var w = -10 + Math.random() * 20
                    data.push({
                        ts: ts_list[i],
                        height: heights[j],
                        spd: spd,
                        dir: dir,
                        w: w,
                    })
                }
            }

            let series_data = []
            data.forEach(function(item) {
                // [日期, height, 高度, spd, dir, w]
                series_data.push([item.ts, item.height, item.spd, item.dir, item.w])
            })

            this.chart_data = series_data
        },
        parsed_data(options) {
            let series_data = []

            const heights = options.height
            const times = options.time
            const spd_list = options.spd
            const dir_list = options.dir
            const w_list = options.w

            times.forEach((ts, idx) => {
                heights.forEach((h, h_idx) => {
                    series_data.push([
                        ts * 1000,
                        h,
                        spd_list[idx][h_idx],
                        dir_list[idx][h_idx],
                        //如果w=無效值(-9999), 不換算
                        w_list[idx][h_idx] === this.setting.invalid_val
                            ? this.setting.invalid_val
                            : w_list[idx][h_idx] * 0.01,
                    ])
                })
            })

            this.chart_data = series_data
        },
        init() {
            this.chart_data = []

            const $el = this.$refs['chart']
            this.target = echarts.init($el)
            this.bind_event()

            const option = {
                title: {
                    textStyle: { fontSize: 16 },
                    padding: 0,
                },
                tooltip: {
                    trigger: 'item',
                    position: function(pos, params, dom, rect, size) {
                        // pos = 滑鼠座標，例如 [x, y]
                        var obj = { top: 0, left: 0 }

                        var viewWidth = size.viewSize[0]
                        var viewHeight = size.viewSize[1]
                        var tooltipWidth = size.contentSize[0]
                        var tooltipHeight = size.contentSize[1]

                        var x = pos[0]
                        var y = pos[1]

                        if (x + tooltipWidth > viewWidth) {
                            obj.left = x - tooltipWidth - 5 // 往左移
                        } else {
                            obj.left = x + 10 // 預設往右
                        }

                        if (y + tooltipHeight > viewHeight - tooltipHeight / 2) {
                            obj.top = y - tooltipHeight > 0 ? y - tooltipHeight : 0 // 往上移, 超出範圍的話置頂
                        } else {
                            obj.top = y + 10 // 預設往下
                        }

                        return obj
                    },
                    formatter: (params) => {
                        const date = echarts.time.format(params.value[0], '{yyyy}-{MM}-{dd} {HH}:{mm}')
                        const height = params.value[1]
                        const spd = params.value[2]
                        const dir = params.value[3]
                        const w = params.value[4]

                        let html = `${date}<br>
                        height: ${height} m<br>
                        spd: ${spd === this.setting.invalid_val ? '----' : spd.toFixed(2)} m/s<br>
                        dir: ${dir === this.setting.invalid_val ? '----' : dir.toFixed(2)}°<br>
                        w: ${w === this.setting.invalid_val ? '----' : w.toFixed(2)} ${this.setting.w.unit}`
                        return html
                    },
                },
                grid: {
                    top: '50',
                    bottom: '80',
                    left: '80',
                    right: '10',
                },
                xAxis: {
                    type: 'time',
                    boundaryGap: '3%', // 添加間距，使Y軸頂部有間距
                    minInterval: 1000 * 60 * 60,
                    maxInterval: 1000 * 60 * 60,
                    axisLabel: {
                        margin: 15,
                        formatter(value) {
                            const h = new Date(value).getHours()
                            if (h === 0) return '{HH}:{mm}\n{MM}/{dd}'
                            return '{HH}:{mm}'
                        },
                    },
                    axisLine: { show: false },
                },
                yAxis: {
                    type: 'value',
                    name: 'Height(m)',
                    nameLocation: 'end',
                    min: this.setting.y.min,
                    max: this.setting.y.max,
                    interval: 500,
                    axisLine: { show: true },
                    axisLabel: {
                        formatter(value) {
                            return value
                        },
                    },
                    splitLine: {
                        show: false, // 不顯示Y軸的橫線
                    },
                },
                series: [],
            }

            option && this.target.setOption(option)
        },
        bind_event() {
            let resizeTimeout

            const onResize = () => {
                clearTimeout(resizeTimeout)
                resizeTimeout = setTimeout(() => {
                    if (this.target) this.target.resize()
                }, 500)
            }
            window.addEventListener('resize', onResize)
        },
        draw_chart() {
            this.title = `${this.chart_options.airport_code}`

            const option = {
                title: {
                    text: `${this.title} Vertical Wind Profile`,
                },
                series: [
                    // {
                    //     //日期線
                    //     type: 'custom',
                    //     renderItem: (params, api) => {
                    //         const point = api.coord([api.value(0), 0]) //起始點
                    //         const x = point[0]
                    //         return {
                    //             type: 'group',
                    //             silent: true,
                    //             children: [
                    //                 {
                    //                     type: 'line',
                    //                     shape: {
                    //                         x1: x,
                    //                         y1: api.coord([api.value(0), this.setting.y.max])[1],
                    //                         x2: x,
                    //                         y2: api.coord([api.value(0), this.setting.y.min])[1],
                    //                     },
                    //                     style: {
                    //                         stroke: '#aaa',
                    //                         lineWidth: 0.5,
                    //                     },
                    //                 },
                    //             ],
                    //         }
                    //     },
                    //     data: this.time_list,
                    // },
                    {
                        //風標
                        type: 'custom',
                        renderItem: (params, api) => {
                            // 風桿(shaft) + 旗幟(flag) + 長線(fletching) + 短線
                            // y軸用高度顯示
                            const point = api.coord([api.value(0), api.value(1)]) //起始點
                            const spd = api.value(2) * 1.944 //速度(ms->kt)
                            const dir = api.value(3) //風向角
                            const w = api.value(4)
                            const radian = this.get_radian(dir) //風桿弧度
                            const flag_radian = this.get_radian(dir + 45) //箭頭旗幟弧度
                            const line_radian = this.get_radian(dir + 50) //箭頭分線弧度
                            const shaft_len = this.setting.barb.len //風桿長度
                            const color = 'black'
                            const is_silent = w === this.setting.invalid_val

                            //起始點->風桿尾端
                            const shaft_xy = {
                                x: shaft_len * Math.cos(radian),
                                y: -shaft_len * Math.sin(radian),
                            }

                            //計算有 N*旗幟 + N*長線 + N*短線
                            const draw_map = this.get_draw_map(spd)
                            let render_items = [] //繪製清單
                            let last_end = shaft_xy //上次繪圖起始點

                            //背景正方框 x:10分鐘 | y:500公尺
                            const [item_w, item_h] = api.size([1000 * 60 * 10, 500])
                            render_items.push({
                                type: 'rect',
                                silent: is_silent,
                                position: point, // 以資料點為原點
                                z: -1, // 在最底層
                                shape: {
                                    x: -item_w / 2, // 置中
                                    y: -item_h / 2,
                                    width: item_w,
                                    height: item_h,
                                },
                                style: {
                                    fill: w === this.setting.invalid_val ? '#aaa' : api.visual('color'),
                                    stroke: 'transparent',
                                    opacity: 0.5,
                                },
                            })

                            //定位紅色原點
                            render_items.push({
                                type: 'circle',
                                silent: is_silent,
                                shape: {
                                    cx: 0,
                                    cy: 0,
                                    r: 2,
                                },
                                style: {
                                    fill: 'red',
                                },
                                position: point,
                            })

                            //無資料=>不畫風標
                            if (w === this.setting.invalid_val) {
                            }
                            //無風=>圓圈
                            else if (!draw_map.length)
                                render_items.push({
                                    type: 'circle',
                                    silent: is_silent,
                                    shape: {
                                        cx: 0,
                                        cy: 0,
                                        r: 4,
                                    },
                                    style: {
                                        fill: 'none',
                                        stroke: color,
                                    },
                                    position: point,
                                })
                            //風桿
                            else
                                render_items.push({
                                    type: 'line',
                                    silent: is_silent,
                                    shape: {
                                        x1: 0,
                                        y1: 0,
                                        x2: shaft_xy.x,
                                        y2: shaft_xy.y,
                                    },
                                    style: {
                                        stroke: color,
                                        lineWidth: 1,
                                    },
                                    position: point,
                                })

                            draw_map.forEach((count, idx) => {
                                if (idx === 0) {
                                    //風標旗幟
                                    new Array(count).fill(1).forEach(() => {
                                        const polygons = this.draw_flag(last_end, radian, flag_radian)
                                        render_items.push({
                                            type: 'polygon',
                                            silent: is_silent,
                                            shape: {
                                                points: polygons.map((o) => [o.x, o.y]),
                                            },
                                            style: {
                                                fill: color,
                                            },
                                            position: point,
                                        })

                                        last_end = polygons[2]
                                    })
                                } else if (idx === 1) {
                                    //風標長線
                                    new Array(count).fill(1).forEach(() => {
                                        const line = this.draw_fletching(last_end, radian, line_radian, 'full')
                                        render_items.push({
                                            type: 'line',
                                            silent: is_silent,
                                            shape: {
                                                x1: line[0].x,
                                                y1: line[0].y,
                                                x2: line[1].x,
                                                y2: line[1].y,
                                            },
                                            style: {
                                                stroke: color,
                                                lineWidth: 0.5,
                                            },
                                            position: point,
                                        })

                                        last_end = line[0]
                                    })
                                } else if (idx === 2) {
                                    //風標短線
                                    new Array(count).fill(1).forEach(() => {
                                        const line = this.draw_fletching(last_end, radian, line_radian, 'half')
                                        render_items.push({
                                            type: 'line',
                                            silent: is_silent,
                                            shape: {
                                                x1: line[0].x,
                                                y1: line[0].y,
                                                x2: line[1].x,
                                                y2: line[1].y,
                                            },
                                            style: {
                                                stroke: color,
                                                lineWidth: 0.5,
                                            },
                                            position: point,
                                        })

                                        last_end = line[0]
                                    })
                                }
                            })

                            return {
                                type: 'group',
                                children: render_items,
                            }
                        },
                        encode: {
                            x: 0,
                            y: 1,
                        },
                        data: this.chart_data,
                    },
                ],
                // 視覺對應：取第 4 維（w = 垂直風速 m/s）
                visualMap: {
                    type: 'piecewise',
                    dimension: 4,
                    orient: 'horizontal',
                    top: 40,
                    right: 0,
                    itemWidth: 12,
                    itemHeight: 12,
                    text: ['10 (m/s)', '-10'],
                    pieces: [
                        { lte: -10, color: '#3E3EFF', label: '-10' },
                        { gt: -10, lte: -5, color: '#5252FF' },
                        { gt: -5, lte: -4, color: '#6464FF' },
                        { gt: -4, lte: -3, color: '#8A8AFF' },
                        { gt: -3, lte: -2, color: '#9F9FFF' },
                        { gt: -2, lte: -1, color: '#B3B3FF' },
                        { gt: -1, lte: -0.5, color: '#D9D9FF' },
                        { gt: -0.5, lte: 0, color: '#FFD9D9' },
                        { gt: 0, lte: 0.5, color: '#FFB3B3' },
                        { gt: 0.5, lte: 1, color: '#FF9F9F' },
                        { gt: 1, lte: 2, color: '#FF8A8A' },
                        { gt: 2, lte: 3, color: '#FF6464' },
                        { gt: 3, lte: 4, color: '#FF5252' },
                        { gt: 4, lte: 10, color: '#FF3E3E' },
                    ],
                },
                visualMap: {
                    type: 'continuous',
                    dimension: 4, // 依 w 上色
                    min: this.setting.w.min,
                    max: this.setting.w.max,
                    orient: 'horizontal',
                    top: 5,
                    right: 0,
                    padding: 0,
                    text: [`${this.setting.w.max} (${this.setting.w.unit})`, `${this.setting.w.min}`],
                    textStyle: {
                        fontSize: 10,
                    },
                    inRange: {
                        color: ['#3E3EFF', '#B3B3FF', '#FFFFFF', '#FF9F9F', '#FF3E3E'],
                    },
                },
            }

            const chart = this.target
            chart.setOption(option)
        },
        get_theta(dir) {
            // 將風向角(dir) 轉為 極座標
            // 風向角的0度為北邊, 90度為東邊, 順時針轉
            // 極座標的0度為東邊, 90度為北邊, 逆時針轉
            let x = -dir + 90
            return x < 0 ? x + 360 : x
        },
        get_radian(dir) {
            //轉成弧度
            const theta = this.get_theta(dir)
            return (theta * Math.PI) / 180
        },
        get_draw_map(kt) {
            if (kt >= 148) return [3, 0, 0]
            else if (kt >= 143) return [2, 4, 1]
            else if (kt >= 138) return [2, 4, 0]
            else if (kt >= 133) return [2, 3, 1]
            else if (kt >= 128) return [2, 3, 0]
            else if (kt >= 123) return [2, 2, 1]
            else if (kt >= 118) return [2, 2, 0]
            else if (kt >= 113) return [2, 1, 1]
            else if (kt >= 108) return [2, 1, 0]
            else if (kt >= 103) return [2, 0, 1]
            else if (kt >= 98) return [2, 0, 0]
            else if (kt >= 93) return [1, 4, 1]
            else if (kt >= 88) return [1, 4, 0]
            else if (kt >= 83) return [1, 3, 1]
            else if (kt >= 78) return [1, 3, 0]
            else if (kt >= 73) return [1, 2, 1]
            else if (kt >= 68) return [1, 2, 0]
            else if (kt >= 63) return [1, 1, 1]
            else if (kt >= 58) return [1, 1, 0]
            else if (kt >= 53) return [1, 0, 1]
            else if (kt >= 48) return [1, 0, 0]
            else if (kt >= 43) return [0, 4, 1]
            else if (kt >= 38) return [0, 4, 0]
            else if (kt >= 33) return [0, 3, 1]
            else if (kt >= 28) return [0, 3, 0]
            else if (kt >= 23) return [0, 2, 1]
            else if (kt >= 18) return [0, 2, 0]
            else if (kt >= 13) return [0, 1, 1]
            else if (kt >= 8) return [0, 1, 0]
            else if (kt >= 3) return [0, 0, 1]
            else if (kt >= 1) return [0, 0, 0]
            else return []
        },
        draw_flag(last_dot, radian, flag_radian) {
            //風標旗幟
            const setting = this.setting
            const start = _get_flag_start_xy(last_dot)
            const end = _get_flag_end_xy(start)
            const close = _get_flag_close_xy(start)

            return [start, end, close]

            function _get_flag_start_xy(point) {
                const len = setting.barb.len * setting.barb.interval //下一起始點距離
                return {
                    x: point.x - len * Math.cos(radian),
                    y: point.y + len * Math.sin(radian),
                }
            }

            function _get_flag_end_xy(point) {
                const len = setting.barb.fletching_len * 1.5
                return {
                    x: point.x + len * Math.cos(flag_radian),
                    y: point.y - len * Math.sin(flag_radian),
                }
            }

            function _get_flag_close_xy(point) {
                const len = setting.barb.len * (setting.barb.interval + 0.08) //旗幟寬度
                return {
                    x: point.x - len * Math.cos(radian),
                    y: point.y + len * Math.sin(radian),
                }
            }
        },
        draw_fletching(last_dot, radian, line_radian, type) {
            //風標分線
            const setting = this.setting
            const start = _get_fletching_start_xy(last_dot)
            const end = _get_fletching_end_xy(start, type)
            return [start, end]

            function _get_fletching_start_xy(point) {
                const len = setting.barb.len * setting.barb.interval //下一起始點距離
                return {
                    x: point.x - len * Math.cos(radian),
                    y: point.y + len * Math.sin(radian),
                }
            }
            function _get_fletching_end_xy(point, type = 'full') {
                const len = type === 'half' ? setting.barb.fletching_len * 0.6 : setting.barb.fletching_len
                return {
                    x: point.x + len * Math.cos(line_radian),
                    y: point.y - len * Math.sin(line_radian),
                }
            }
        },

        close_dialog() {
            this.$emit('close-chart-dialog')
        },

        save_png() {
            const file_name = `Vertical_Wind_Profile_${this.title}`
            const node = document.querySelector('#base-popup__capture_range')
            take_screenshot(node, file_name)
        },
    },
    watch: {
        chart_options() {
            this.draw()
        },
        chart_data() {
            this.draw_chart()
        },
    },
}
</script>

<style lang="scss" scoped>
@import '../../../css/base_popup';
</style>

<style scoped>
.wind-profiler {
    display: flex;
    flex-direction: column;
    height: 25rem;
    max-height: 50vh;
    padding: 0 1rem;
}
.wind-profiler-chart {
    flex: 1;
    width: 100%;
    height: 100%;
}
</style>
